import React from "react";
import { FaGooglePlay } from "react-icons/fa";
import screenshotImage from "../../assets/shadow-dial/screenshots/1.webp";
import iconImage from "../../assets/shadow-dial/icon.webp";
import "./ShadowDial.scss";

const ShadowDial = () => {
  return (
    <div className="shadow-dial">
      <section className="hero">
        <div className="hero__container">
          <div className="hero__content animate-on-scroll">
            <div className="app-icon">
              <img src={iconImage} width={80} height={80} alt="App Icon" />
            </div>
            <h1 className="hero__title">ShadowDial</h1>
            <p className="hero__subtitle">
              The perfect excuse is just one tap away
            </p>
            <p className="hero__description">
              Create realistic fake calls for any situation. Whether you need an
              escape route, conversation practice, or a harmless prank,
              ShadowDial has you covered.
            </p>
            <div className="hero__actions">
              <a
                href="https://play.google.com/store/apps/details?id=diozz.shadowdial"
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn"
              >
                <FaGooglePlay />
                <span>Download on Play Store</span>
              </a>
            </div>
          </div>
          <div className="hero__image animate-on-scroll">
            <div className="phone-mockup">
              <div className="screen">
                <img
                  src={screenshotImage}
                  alt="ShadowDial App Screenshot"
                  className="screenshot-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ShadowDial;
